<template>
<b-modal id="acoModal" :title="modalTitle" size="lg" ok-title="Save" @ok="handleOk" ref="modal">
  <b-container fluid>

    <b-form ref="addressForm" @submit.prevent="handleSubmit">
      <!-- <b-form-row>
          <b-form-group label="Nickname" label-for="nickname">
            <b-form-input id="nickname" type="text" v-model="form.name" required placeholder="Home">
            </b-form-input>
          </b-form-group>
        </b-form-row> -->
        <label>Product Details</label>
        <b-form-row>
          <b-col>
          <b-form-group label="Product" label-for="product">
            <b-form-select id="product" :options="products" required v-model="productForm.id" />
          </b-form-group>
          <b-form-group label="Size" label-for="size">
            <b-form-select id="size" :options="sizes" required v-model="productForm.size" />
          </b-form-group>

          <b-form-group label="Color" label-for="style">
            <b-form-select id="style" :options="styles" v-model="productForm.style" />
          </b-form-group>
          </b-col>
        </b-form-row>
      <label>Shipping Address</label>
      <b-form-row>


      <b-col>
        <b-form-group label="First Name" label-for="First Name">
          <b-form-input id="address1" v-model="form.firstName" type="text" required placeholder="First Name" />
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Last Name" label-for="address1">
          <b-form-input id="address1" v-model="form.lastName" type="text" required placeholder="last Name" />
        </b-form-group>
      </b-col>
      </b-form-row>
      <b-form-row>

      <b-col>
        <b-form-group label="Email" label-for="address1">
          <b-form-input id="address1" v-model="email" type="text" required placeholder="Email" />
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Phone Number" label-for="address1">
          <b-form-input id="address1" v-model="phone" type="text" required placeholder="no dashes" />
        </b-form-group>
      </b-col>
      </b-form-row>
      <b-form-row>

      <b-col>
        <b-form-group label="Address Line 1" label-for="address1">
          <b-form-input id="address1" v-model="form.address1" type="text" required placeholder="1 Main st" />
        </b-form-group>
      </b-col>

          <b-form-group label="Address Line 2" label-for="address2">
            <b-form-input id="address2" v-model="form.address2" type="text" placeholder="Unit 5b" />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col>
          <b-form-group label="City" label-for="city">
            <b-form-input id="city" v-model="form.city" type="text" required placeholder="New York" />
          </b-form-group>
        </b-col>
        <b-col>

          <b-form-group label="Zip Code" label-for="zip">
            <b-form-input id="zip" v-model="form.zip" type="text" required placeholder="10001" />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group label="Country" label-for="country">
            <b-form-select id="country" :options="countries" required v-model="form.country" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="State" label-for="state">
            <b-form-input type="text" id="state" v-model="form.state" required />
          </b-form-group>
        </b-col>
        <div id="billing" v-if="!matchInfo">
      <b-form-row>
        <b-col>
          <b-form-group label="Address Line 1" label-for="address1">
            <b-form-input id="address1" v-model="form.address1" type="text" required placeholder="1 Main st" />
          </b-form-group>
        </b-col>
        <b-col>

          <b-form-group label="Address Line 2" label-for="address2">
            <b-form-input id="address2" v-model="form.address2" type="text" required placeholder="Unit 5b" />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row>
        <b-col>
          <b-form-group label="City" label-for="city">
            <b-form-input id="city" v-model="form.city" type="text" required placeholder="New York" />
          </b-form-group>
        </b-col>
        <b-col>

          <b-form-group label="Zip Code" label-for="zip">
            <b-form-input id="zip" v-model="form.zip" type="text" required placeholder="10001" />
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col>
          <b-form-group label="Country" label-for="country">
            <b-form-select id="country" :options="countries" required v-model="form.country" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="State" label-for="state">
            <b-form-input type="text" id="state" v-model="form.state" required />
          </b-form-group>
        </b-col>
      </b-form-row>
    </div>
      </b-form-row>
        <label>Card</label>
      <b-form-row>
        <!-- <label>Card</label> -->
        <b-col>

          <b-form-group label="Type" label-for="type">
            <b-form-select id="type"  required v-model="cardForm.type">

              <option :value="null">Select Type</option>
              <option value="visa">Visa</option>
              <option value="mastercard">Mastercard</option>
              <option value="americanexpress">American Express</option>
              <option value="discover">Discover</option>
            </b-form-select>
          </b-form-group>
          </b-form-group>
          <b-form-group label="Card Number" label-for="cardNum">
            <b-form-input id="cardNum" v-model="cardForm.number" type="text" required placeholder="411111111111111" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Card Expiration" label-for="cardExp">
            <b-form-input id="cardExp" v-model="cardForm.exp" type="text" required placeholder="01/22" />
          </b-form-group>

          <b-form-group label="Card CVV" label-for="cardNum">
            <b-form-input id="cardCVV" v-model="cardForm.code" type="text" required placeholder="953" />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-button type="submit" variant="primary" v-show="false" ref="submitButton">Submit</b-button>
    </b-form>
  </b-container>
</b-modal>
</template>
<script>
import {orderService}from '@/services/order'
let countries = [
  { value: "US", text: "US" },
  { value: "GB", text: "GB" },
  // { value: null, text: "Select Country" },
  // { value: "a", text: "This is First option" },
  // { value: "b", text: "Selected Option" },
  // { value: { C: "3PO" }, text: "This is an option with object value" },
  // { value: "d", text: "This one is disabled", disabled: true }
]

export default {
  name: 'AddressModal',
  props: {
    //form: Object,
    onSave: Function()
  },
  mounted() {
    this.getProducts()
  },
  data() {
    return {
      products: [],
      sizes: [
        'xs',
        's',
        'm',
        'l',
        'xl',
        'os',
      ],
      shoeSizes: [


      ],
      email: '',
      matchInfo: true,
      phone: null,
      productForm: {
        id: this.$route.query.productId || null,
        title: null,
        style: this.$route.query.style || null,
        size: this.$route.query.size || null,
      },
      form: {
        firstName: null,
        lastName: '',
        address1: "",
        address2: "",
        zip: '',
        city: "",
        country: null,
        state: "",
      },
      billingForm: {
        firstName: null,
        lastName: '',
        address1: "",
        address2: "",
        zip: '',
        city: "",
        country: null,
        state: "",

      },
      cardForm: {
        number: null,
        code: null,
        month: null,
        year: null,
        type: null,
        exp: null,

      },
      modalTitle: "ACO Details",
      countries: countries,
    };
  },
  computed: {
    selectedProduct() {
      let product = this.products.find(p=>p.productId == this.productForm.id)
      return product
    },
    styles() {
      if(this.product && this.product.styles) {
        let split = this.product.styles.split(',')
        if(split && split.length > 0) {
          return split
        } else {
          return [{text: 'One Color',value: null}]
        }

      } else {
          return [{text: 'One Color',value: null}]
      }
    },


    builtData() {
      let valid = this.verifyData()
      if(!valid) return
      let dataPayload = {
        productForm:this.productForm,
        billing: this.billingForm,
        shipping: this.form,
        phone: this.phone,
        email: this.email,
        card: this.cardForm
      }
      return dataPayload
    }
  },
  watch: {
  '$route'(to,from) {
    // react to route changes...
    let {productId }= this.$route.query
    if(productId) this.productId = productId
  },
},

  methods: {
    async getProducts() {
      let prducts  = await orderService.getProducts() // for some reason this works
      let productTitles = []
      prducts.forEach((product) => {
        let x = {text:product.productTitle, value:product.productId, price:product.price}
        productTitles.push(x)
      })
      this.products = productTitles

    },
    validateAddress(a) {
return true
      if(!a.firstName || !a.lastName || !a.address1 || !a.zip || !a.city || !a.country) return false
      return true
    },
    validateCard(card) {
      let {number,code,month,year} = card
      if(!number || !code || !month || !year) return false
      return true
    },
    verifyData() {
      let {billingForm,form,cardForm,email,phone,matchInfo} = this
      if(matchInfo) billingForm = form
      if(!this.validateAddress(form) || !this.validateAddress(billingForm)) {
        console.error('invalid address')
        return false
      }
      if(!email || !phone){
        console.error('invalid email or phone #')
        return true
      }
      return true

    },
    buildData() {
      let valid = this.verifyData()
      if(!valid) return console.log(`invalid aco data`)
      let dataPayload = {
        productForm:this.productForm,
        billing: this.billingForm,
        shipping: this.form,
        phone: this.phone,
        email: this.email,
        card: this.cardForm
      }
      let x = this.products.find(p=> p.value == this.productForm.id)
      dataPayload.productForm.title = x.text
      dataPayload.productForm.price = x.price
    return dataPayload

    },
    getExp() {
      let {exp} = this.cardForm
      let split = exp.split('/')
      if(!split) return
      let month = split[0]
      let year = split[1]
      if(!month || !year) return
      if(year.length == 2) {
        let yearString = '20' + year.toString()
        year = parseInt(yearString)
      }
      if(year.length != 2 || year.length != 4) {
        console.log(`invalid exp year`)
        return
      }
      this.cardForm.month = month
      this.cardForm.year = year
      console.log(`set month to ${this.cardForm.month} and year to ${this.cardForm.year}`)
    },
    handleOk(evt) {
      evt.preventDefault()
      // console.log(this.$refs)
      this.$refs.submitButton.click();
    },
    handleSubmit() {
      console.log('form submitted')
      this.getExp()
      let valid = this.verifyData()
      if(!valid) {
        return console.error(`invalid aco data`)
      }
      let dataPayload = this.buildData()
      console.log(`built aco data payload`,dataPayload)
      this.$store.commit('orders/setAco',dataPayload)
      console.log(`commited aco Data to vuex`)
      this.$refs.addressForm.reset()
      this.$nextTick(() => {
    this.$refs.modal.hide()
  })
    }
  }
};
</script>
<style>

.btn-secondary {
  background-color: red;
}
</style>
